import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ProfSpacGrid from '../component/ProfSpacGrid';
const profSpacPage = () => {
  return (
    <>
      <h2 className={'TitleGrid'}>
        <Trans>Profile Spac</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ProfSpacGrid />
    </>
  );
};

export default profSpacPage;
